import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { clearPageStateGuard } from './modules/shared/guards/clear-page-state.guard';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  //Home
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  // Auth
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },

  //Home Dashboard
  {
    path: 'home',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
  },

  // Usuários
  {
    path: 'usuarios',
    loadChildren: () =>
      import('./modules/usuario/usuario.module').then((m) => m.UsuarioModule),
  },

  // Veículos
  {
    path: 'veiculos',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/veiculo/veiculo.module').then((m) => m.VeiculoModule),
  },

  // Perfil de usuário
  {
    path: 'perfil-usuario',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/perfil-usuario/perfil-usuario.module').then(
        (m) => m.PerfilUsuarioModule,
      ),
  },

  // Entidades
  {
    path: 'entidades',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/entidade/entidade.module').then(
        (m) => m.EntidadeModule,
      ),
  },

  // Contratos
  {
    path: 'contratos',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/contrato/contrato.module').then(
        (m) => m.ContratoModule,
      ),
  },

  // Permissões
  {
    path: 'permissoes',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/permissao/permissao.module').then(
        (m) => m.PermissaoModule,
      ),
  },

  // Permissionário
  {
    path: 'permissionarios',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/permissionario/permissionario.module').then(
        (m) => m.PermissionarioModule,
      ),
  },

  // Auxiliar
  {
    path: 'auxiliares',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/auxiliar-permissao/auxiliar-permissao.module').then(
        (m) => m.AuxiliarPermissaoModule,
      ),
  },

  // Agendas
  {
    path: 'agendas',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/agenda/agenda.module').then((m) => m.AgendaModule),
  },

  // Movimentação
  {
    path: 'movimentacoes',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/movimentacao/movimentacao.module').then(
        (m) => m.MovimentacaoModule,
      ),
  },

  // Vistoria
  {
    path: 'vistorias',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/vistoria/vistoria.module').then(
        (m) => m.VistoriaModule,
      ),
  },

  // Taxi
  {
    path: 'taxis',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/taxi/taxi.module').then((m) => m.TaxiModule),
  },

  // Grupos Tarifarios
  {
    path: 'grupos-tarifarios',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/grupo-tarifario/grupo-tarifario.module').then(
        (m) => m.GrupoTarifarioModule,
      ),
  },

  // Terminais
  {
    path: 'terminais',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/terminal/terminal.module').then(
        (m) => m.TerminalModule,
      ),
  },

  // Atendimentos
  {
    path: 'atendimentos',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/linha/linha.module').then((m) => m.LinhaModule),
  },

  // Rota legada: o menu do banco ainda aponta para /linhas
  { path: 'linhas', redirectTo: 'atendimentos' },

  // Calendario
  {
    path: 'calendarios',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/calendario/calendario.module').then(
        (m) => m.CalendarioModule,
      ),
  },

  // Assinaturas
  {
    path: 'assinaturaspendentes',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/assinatura/assinatura.module').then(
        (m) => m.AssinaturaModule,
      ),
  },

  //qco
  {
    path: '',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/qco/qco.module').then((m) => m.QcoModule),
  },

  //certidoes
  {
    path: 'certidao',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/certidao/certidao.module').then(
        (m) => m.CertidaoModule,
      ),
  },

  //pendencias
  {
    path: 'pendencias',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/pendencia/pendencia.module').then(
        (m) => m.PendenciaModule,
      ),
  },

  //Cadastros auxiliares
  {
    path: 'especificacoes',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/cadastro-auxiliar/cadastro-auxiliar.module').then(
        (m) => m.CadastroAuxiliarModule,
      ),
  },

  //MCO
  {
    path: 'mco',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/mco/mco.module').then((m) => m.McoModule),
  },

  // Relatórios
  {
    path: 'emitir-relatorio',
    canActivate: [MsalGuard, clearPageStateGuard],
    loadChildren: () =>
      import('./modules/relatorio/relatorio.module').then(
        (m) => m.RelatorioModule,
      ),
  },

  // Wildcard route for non-existent routes
  { path: 'code', redirectTo: 'auth/login' },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
